import * as c from "./constant";

export const setMerchants = (merchants) => ({
  type: c.SET_MERCHANTS,
  payload: merchants,
});

export const setIsRequired = (required) => ({
  type: c.SET_MERCHANT_REQUIRED,
  payload: required,
});
